<div class="profile-container">
  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="spinner-container">
    <mat-spinner class="small-spinner"></mat-spinner>
  </div>

  <!-- Error Message -->
  <div *ngIf="!isLoading && errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <!-- Profile Content -->
  <div *ngIf="!isLoading && !errorMessage">
    
    <!-- User Profile Card -->
    <mat-card *ngIf="user" class="profile-card" appearance="outlined">
      <mat-card-header class="card-header">
        <div class="header-content">
          <mat-card-title class="profile-title">
            <mat-icon class="title-icon">person</mat-icon>
            Profile
          </mat-card-title>
          <mat-card-subtitle>Manage your personal information</mat-card-subtitle>
        </div>
        <mat-card-actions class="header-actions">
          <button mat-icon-button color="primary" (click)="toggleEdit()" aria-label="Edit Profile">
            <mat-icon>{{ isEditing ? 'cancel' : 'edit' }}</mat-icon>
          </button>
          <button mat-icon-button color="accent" *ngIf="isEditing" (click)="saveUserDetails()" aria-label="Save Profile">
            <mat-icon>save</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card-header>
      
      <mat-card-content class="profile-content">
        <form [formGroup]="userForm" class="profile-form">
          <div class="form-row">
            <mat-form-field class="form-field" appearance="outline">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="Firstname">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="userForm.get('Firstname')?.hasError('required')">
                First Name is required.
              </mat-error>
            </mat-form-field>

            <mat-form-field class="form-field" appearance="outline">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="Lastname">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="userForm.get('Lastname')?.hasError('required')">
                Last Name is required.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field class="form-field" appearance="outline">
              <mat-label>Phone</mat-label>
              <input matInput formControlName="Phone">
              <mat-icon matSuffix>phone</mat-icon>
              <mat-error *ngIf="userForm.get('Phone')?.hasError('required')">
                Phone is required.
              </mat-error>
              <mat-error *ngIf="userForm.get('Phone')?.hasError('pattern')">
                Invalid phone number.
              </mat-error>
            </mat-form-field>

            <mat-form-field class="form-field" appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput formControlName="Email" [disabled]="true">
              <mat-icon matSuffix>email</mat-icon>
              <mat-hint>Email cannot be changed</mat-hint>
            </mat-form-field>
          </div>
        </form>
      </mat-card-content>
    </mat-card>

  </div>
</div>
